/**
 * Created by yeojinyoon on 2015-05-25.
 */
(function(){
  "use strict";

  angular.module('eclipseApp.checkout').controller('decisionModalCtrl', ['$scope', '$injector', '$modalInstance', '$window', '$state', 'data', function ($scope, $injector, $modalInstance, $window, $state, data) {

    $scope.displayMessage = data.displayMessage;
    $scope.showNewCustomerButton = data.showNewCustomerButton;

    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      data.focusEmail();
      $modalInstance.close();
    };

    $scope.login = function(){
      $modalInstance.close();
      $window.janrain.capture.ui.renderScreen('signIn');
    };

    $scope.continue = function(){
      if (data.parent && data.parent.processCheckout) {
        $state.go(data.processRoute);
      }
      else if(data.formData){
        $scope.emptyEmail();
      }

      $modalInstance.close();
    };

    $scope.emptyEmail = function(){

      if(data.formData) {
        setTimeout(function () {
          document.getElementById('email').focus();
        }, 500);
        console.log('email address', data.formData.email_address);
        data.formData.email_address = '';
        data.formData.confirmEmail = '';
        data.formData.__completed = false;
      }
    };

  }]);

})();
